/**
 * Имя заголовка для сквозного `request_id`: middleware выставляет его на входе,
 * `resolveRequestId` читает на сервере, исходящий `fetch` к бэку пробрасывает тот же id.
 */
export const REQUEST_ID_HEADER = 'x-request-id';

/**
 * Входящий флаг: логировать SSR API request/response (терминал + панель в HTML).
 * Только заголовок запроса: `x-algocode-ssr-debug: 1`.
 */
export const SSR_DEBUG_HEADER = 'x-algocode-ssr-debug';
